<template>
    <div class="grid-narrow-left-column SectionBorderTop">
        <div class="left">
            <div class="icon"><CalendarIcon :color="'#d8d9d4'" class="calendarIcon" /></div>
        </div>
        <div class="right"><DateInfosDetail :forecast="forecast" :forecast-window="forecastWindow" /></div>
    </div>
</template>
<script>
import CalendarIcon from "@/components/forecasts/elements/icons/CalendarIcon";
import DateInfosDetail from "@/components/forecasts/elements/general/DateInfosDetail";
export default {
    components: { DateInfosDetail, CalendarIcon },
    props: {
        forecast: {
            type: Object,
            required: true
        },
        forecastWindow: {
            type: Object,
            required: false
        }
    }
};
</script>
<style scoped lang="scss">
@import "../../css/forecasts";
.calendarIcon {
    width: 60px;
    height: 60px;
    vertical-align: center;
    margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// CalendarInfo.vue?94439fd2